import { Box, MenuItem } from '@mui/material';
import { CustomTextField, CustomAutoComplete, CustomButton } from '../../../common/components';

const CashRetentionsFilters = ({
  filters,
  onFilterChange,
  searchTerm,
  onSearchChange,
  reconciliationFilter,
  onReconciliationChange,
  typeFilter,
  onTypeChange,
  allowedMovementTypes = [],
  onExport,
}) => (
  <Box
    sx={{
      backgroundColor: 'background.paper',
      p: 2,
      display: 'flex',
      flexWrap: 'wrap',
      gap: 2,
      alignItems: 'flex-end',
    }}
  >
    <CustomTextField
      label="Desde"
      type="date"
      value={filters.startDate}
      onChange={(event) => onFilterChange('startDate', event.target.value)}
      size="medium"
      sx={{ width: { xs: '100%', sm: 180 } }}
    />

    <CustomTextField
      label="Hasta"
      type="date"
      value={filters.endDate}
      onChange={(event) => onFilterChange('endDate', event.target.value)}
      size="medium"
      sx={{ width: { xs: '100%', sm: 180 } }}
    />

    <CustomTextField
      placeholder="Buscar por concepto, comprobante o beneficiario"
      value={searchTerm}
      onChange={(event) => onSearchChange(event.target.value)}
      size="medium"
      sx={{ flex: 1, minWidth: 200 }}
    />

    <CustomAutoComplete
      label="Conciliado"
      value={reconciliationFilter}
      onChange={(event) => onReconciliationChange(event.target.value)}
      size="medium"
      sx={{ width: { xs: '100%', sm: 150 } }}
    >
      <MenuItem value="all">Todos</MenuItem>
      <MenuItem value="reconciled">Sí</MenuItem>
      <MenuItem value="pending">No</MenuItem>
    </CustomAutoComplete>

    <CustomAutoComplete
      label="Tipo"
      value={typeFilter}
      onChange={(event) => onTypeChange(event.target.value)}
      size="medium"
      sx={{ width: { xs: '100%', sm: 220 } }}
    >
      <MenuItem value="all">Todos</MenuItem>
      {allowedMovementTypes.map((type) => (
        <MenuItem key={type.uuid} value={type.uuid}>
          {type.description}
        </MenuItem>
      ))}
    </CustomAutoComplete>

    <CustomButton variant="info" onClick={onExport}>
      Exportar a Excel
    </CustomButton>
  </Box>
);

export default CashRetentionsFilters;
